export enum _COURSE_STORE {
  /* Mutations */
  SET_COURSE_INFO_M = 'CourseStore/setCourseInfo',
  UPDATE_ORDER_SECTIONS_M = 'CourseStore/updateOrderSections',
  UPDATE_SECTION_M = 'CourseStore/updateSection',
  CREATE_SECTION_M = 'CourseStore/createSection',
  REMOVE_SECTION_M = 'CourseStore/removeSection', 
  REMOVE_COURSE_MATERIAL_M = 'CourseStore/removeCourseMaterial', 
  REMOVE_COURSE_MATERIAL_SECTION_M = 'CourseStore/removeCourseMaterialSection', 
  SET_COURSES_M = 'CourseStore/setCourses', 
  SET_PREVIEW_SELECTED_M = 'CourseStore/setPreviewSelected', 
  SET_COURSE_MATERIAL_M = 'CourseStore/setCourseMaterial',
  UPDATE_COURSE_MATERIAL_M = 'CourseStore/updateCourseMaterial',
  SET_COURSE_MATERIAL_SECTION_M = 'CourseStore/setCourseMaterialSection',
  SET_CONTENT_FOR_COURSE_M = 'CourseStore/setContentForCourse',
  SET_TEACHER_ONLY_SECTION_M = 'CourseStore/setTeacherOnlySection',
  UPDATE_MATERIAL_SECTION_NAME_M = 'CourseStore/updateMaterialSectionName',
  SET_COMPONENT_SELECTED_M = 'CourseStore/setComponentSelected',
  SET_COURSE_MODE_M = 'CourseStore/setCourseMode',
  SET_MOVING_OBJECT_M = 'CourseStore/setMovingObject',
  SET_PRESENTATION_TEACHER_MODE_M = 'CourseStore/setPresentationTeacherMode',
  SET_PRESENTATION_STUDENT_MODE_M = 'CourseStore/setPresentationStudentMode',
  UPDATE_PRESENTATION_COURSE_SELECTED_M = 'CourseStore/updatePresentationCourseSelected',
  SET_PRESENTATION_COURSES_M = 'CourseStore/setPresentationCourses',
  SET_ZOOM_OBJECT_M = 'CourseStore/setZoomObject',
  IS_SPLIT_HORIZONTAL_M = 'CourseStore/isSplitHorizontal',
  IS_SPLIT_VERTICAL_M = 'CourseStore/isSplitVertical',
  SET_PDF_LOADING_M = 'CourseStore/setPdfLoading',
  SET_COMPLETED_TASK_BY_SECTION_M = 'CourseStore/setCompletedTaskBySection',
  SET_SHOW_SECTION_PERSON_COURSE_VIEWER_M = 'CourseStore/setShowSectionPersonCourseViewer',
  SET_IMAGES_LOADING_M = 'CourseStore/setImagesLoading',
  SET_VIDEO_LOADING_M = 'CourseStore/setVideoLoading',
  SET_GRADING_DETAILS_FOR_COURSE_M = 'CourseStore/setGradingDetailsForCourse',
  CREATE_PROJECT_M = 'CourseStore/createProject',
  UPDATE_PROJECT_M = 'CourseStore/updateProject',
  REMOVE_PROJECT_M = 'CourseStore/removeProject',
  UPDATE_ORDER_PROJECTS_M = 'CourseStore/updateOrderProjects',
  SAVE_PROJECT_FILES_M = 'CourseStore/saveProjectFiles',
  SET_IS_BOARD_SECTION_HOMEWORK_M = 'CourseStore/setIsBoardSectionHomework',
  REVERT_SECTION_MOVED_M = 'CourseStore/revertSectionMoved',
  REMOVE_SECTION_FROM_PARENT_M = 'CourseStore/removeSectionFromParent',
  UPDATE_DECK_M = 'CourseStore/updateDeck',
  CREATE_DECK_M = 'CourseStore/createDeck',
  REMOVE_DECK_M = 'CourseStore/removeDeck',
  REFRESH_DECK_M = 'CourseStore/refreshDeck',
  UPDATE_CARD_M = 'CourseStore/updateCard',
  CREATE_CARD_M = 'CourseStore/createCard',
  REMOVE_CARD_M = 'CourseStore/removeCard',
  SET_CURRENT_CARD_INFO_M = 'CourseStore/setCurrentCardInfo',
  SET_CURRENT_MENU_OPTIONS_M = 'CourseStore/setCurrentMenuOptions',
  RESET_SECTION_TO_EDIT_M = 'CourseStore/resetSectionToEdit',
  EDUAC_COMPONENT_SELECTED_M = 'CourseStore/setEduacComponentSelected',

  // SET_COURSE_CONTENT: 'setCourseContent', /* Deprecated */
  // CREATE_OBJECT: 'createObject', /* Deprecated */
  // IMPORT_COURSE_MATERIAL: 'importCourseMaterial', /* Deprecated */
  // SET_COURSES_ALREADY_LOADED: 'setCoursesAlreadyLoaded',  /* Deprecated -> My content store */
  // UPDATE_MATERIAL_SECTION: 'updateMaterialSection', /* Deprecated */
  // SET_PROJECT_SECTION: 'setProjectSection', /* Deprecated */
  // SET_STUDENTS_IN_COURSE: 'setStudentsInCourse',  /* Deprecated */
  // SET_SECTION_OPENED_MODE: 'setSectionOpenedMode', /* Deprecated */
  // SET_PAGE_NAME: 'setPageName', /* Deprecated -> My content store */

  /* Actions */
  ADD_COURSE_MATERIAL_A =  'CourseStore/addCourseMaterial',
  REMOVE_COURSE_MATERIAL_A = 'CourseStore/removeCourseMaterial',
  GET_COURSE_INFO_A = 'CourseStore/getCourseInfo',
  GET_CONTENT_BY_EDITOR_A = 'CourseStore/getContentByEditor',
  GET_CONTENT_FOR_COURSE_A = 'CourseStore/getContentForCourse',
  GET_COURSES_A = 'CourseStore/getCourses',
  REMOVE_IMG_FROM_SECTION_A = 'CourseStore/removeImgFromSection',
  UPDATE_SECTION_A = 'CourseStore/updateSection',
  CREATE_SECTION_A = 'CourseStore/createSection',
  REORDER_SECTION_A = 'CourseStore/reorderSection',
  REMOVE_FILE_A = 'CourseStore/removeFile',
  REMOVE_SECTION_A = 'CourseStore/removeSection',
  CREATE_SECTION_FROM_OBJECT_A = 'CourseStore/createSectionFromObject',
  COPY_SECTION_A = 'CourseStore/copySection',
  CREATE_COURSE_MATERIAL_SECTION_A = 'CourseStore/createCourseMaterialSection',
  UPDATE_SECTION_MATERIAL_A = 'CourseStore/updateSectionMaterial',
  REMOVE_SECTION_MATERIAL_A = 'CourseStore/removeSectionMaterial',
  UPDATE_COURSE_MATERIAL_SECTION_A = 'CourseStore/updateCourseMaterialSection',
  MOVE_COURSE_MATERIAL_A = 'CourseStore/moveCourseMaterial',
  MOVE_COURSE_MATERIAL_SECTION_A = 'CourseStore/moveCourseMaterialSection',
  CREATE_WRITE_OBJECT_A = 'CourseStore/createWriteObject',
  UPDATE_WRITE_OBJECT_A = 'CourseStore/updateWriteObject',
  UPDATE_COURSE_MATERIAL_A = 'CourseStore/updateCourseMaterial',
  UPDATE_SECTION_MATERIAL_VISIBILITY_A = 'CourseStore/updateSectionMaterialVisibility',
  UPDATE_COURSE_FILES_INFO_READY_A = 'CourseStore/updateCourseFilesIfInfoReady',
  UPDATE_COURSE_MATERIAL_INFO_READY_A = 'CourseStore/updateCourseMaterialIfInfoReady',
  UPDATE_FILE_A = 'CourseStore/updateFile',
  ROTATE_CONTENT_ASSET_A = 'CourseStore/rotateContentAsset',
  SET_TEACHER_ONLY_SECTION_A = 'CourseStore/setTeacherOnlySection',
  GET_PRESENTATION_COURSES_A = 'CourseStore/getPresentationCourses',
  GET_COMPLETED_TASK_BY_STUDENT_A = 'CourseStore/getCompletedTaskByStudent',
  GET_GRADING_DETAILS_FOR_COURSE_A ='CourseStore/getGradingDetailsForCourse',
  CREATE_PROJECT_A = 'CourseStore/createProject',
  UPDATE_PROJECT_A = 'CourseStore/updateProject',
  REMOVE_PROJECT_A = 'CourseStore/removeProject',
  REORDER_PROJECT_A = 'CourseStore/reorderProject',
  SAVE_PROJECT_FILES_A = 'CourseStore/saveProjectFiles',
  GET_COURSE_EDITION_A = 'CourseStore/getCourseEdition',
  // GET_COURSE_CONTENT: 'getContent', /* Deprecated */
  /* Components Actions */
  CREATE_EDUAC_COMPONENT = 'CourseStore/createComponent',
  UPDATE_EDUAC_COMPONENT = 'CourseStore/updateComponent',
  REMOVE_EDUAC_COMPONENT = 'CourseStore/removeComponent',
  /* Components Mutations*/
  ADD_EDUAC_COMPONENT = 'CourseStore/addComponent',
  SET_EDUAC_COMPONENT = 'CourseStore/setComponent',
  DELETE_EDUAC_COMPONENT = 'CourseStore/deleteComponent',
  CREATE_DECK_A = 'CourseStore/createDeck',
  UPDATE_DECK_A = 'CourseStore/updateDeck',
  REMOVE_DECK_A = 'CourseStore/removeDeck',
  REFRESH_DECK_A = 'CourseStore/refreshDeck',
  REFRESH_SECTIOM_STRUCTURE_A = 'CourseStore/refreshSectionStructure',
  CREATE_CARD_A = 'CourseStore/createCard',
  UPDATE_CARD_A = 'CourseStore/updateCard',
  REMOVE_CARD_A = 'CourseStore/removeCard',
  MOVE_CARD_A = 'CourseStore/moveCard',
  CREATE_SUB_DECK_A = 'CourseStore/createSubDeck',
  UPDATE_SUB_DECK_A = 'CourseStore/updateSubDeck',
}